// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1S6ku","noInteraction":"EventWrapper_noInteraction__zN69-"};